import type { UserRole } from '@/api/types'

const ROLE_CLASS: Record<UserRole, string> = {
  owner: 'badge badge--role badge--role-owner',
  finance: 'badge badge--role badge--role-finance',
  finance_admin: 'badge badge--role badge--role-finance',
  admin: 'badge badge--role badge--role-admin',
  system_admin: 'badge badge--role badge--role-admin',
  viewer: 'badge badge--role badge--role-viewer',
  reviewer: 'badge badge--role badge--role-viewer',
}

const ROLE_LABEL: Record<UserRole, string> = {
  owner: 'Owner',
  finance: 'Finance',
  finance_admin: 'Finance admin',
  admin: 'Admin',
  system_admin: 'System admin',
  viewer: 'Viewer',
  reviewer: 'Reviewer',
}

export function RoleBadge({ role }: { role: UserRole }) {
  return <span className={ROLE_CLASS[role] ?? 'badge badge--role'}>{ROLE_LABEL[role] ?? role}</span>
}
